export default __webpack_public_path__ + "7f7dc7626a533d161a55662d8f7c4d07.png";